var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobFailureOtp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 3C15.0883 3 3 15.0883 3 30C3 44.9117 15.0883 57 30 57C44.9117 57 57 44.9117 57 30C57 15.0883 44.9117 3 30 3ZM21.841 18.659C20.9623 17.7803 19.5377 17.7803 18.659 18.659C17.7803 19.5377 17.7803 20.9623 18.659 21.841L26.818 30L18.659 38.159C17.7803 39.0377 17.7803 40.4623 18.659 41.341C19.5377 42.2197 20.9623 42.2197 21.841 41.341L30 33.182L38.159 41.341C39.0377 42.2197 40.4623 42.2197 41.341 41.341C42.2197 40.4623 42.2197 39.0377 41.341 38.159L33.182 30L41.341 21.841C42.2197 20.9623 42.2197 19.5377 41.341 18.659C40.4623 17.7803 39.0377 17.7803 38.159 18.659L30 26.818L21.841 18.659Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobFailureOtp);
export default __webpack_public_path__ + "static/media/mob-failure-otp.839d4737fe53f5477d2a546972ba8d6c.svg";
export { ForwardRef as ReactComponent };